"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLazyCborObj = void 0;
var CborObj_1 = require("../CborObj/index.js");
var LazyCborArray_1 = require("./LazyCborArray.js");
var LazyCborMap_1 = require("./LazyCborMap.js");
var LazyCborTag_1 = require("./LazyCborTag.js");
function isLazyCborObj(cborObj) {
    var proto = Object.getPrototypeOf(cborObj);
    // only strict instances
    return (proto === CborObj_1.CborNegInt.prototype ||
        proto === CborObj_1.CborUInt.prototype ||
        proto === CborObj_1.CborBytes.prototype ||
        proto === CborObj_1.CborText.prototype ||
        proto === LazyCborArray_1.LazyCborArray.prototype ||
        proto === LazyCborMap_1.LazyCborMap.prototype ||
        proto === LazyCborTag_1.LazyCborTag.prototype ||
        proto === CborObj_1.CborSimple.prototype);
}
exports.isLazyCborObj = isLazyCborObj;
